import { SET_CURRENT_USER, UPDATE_USER } from "../actionTypes"

const DEFAULT_STATE = {
  isAuthenticated: false,
  user: {}
}

export default (state=DEFAULT_STATE, action=null) => {
  switch(action.type) {
    case SET_CURRENT_USER:
      return {
        isAuthenticated: !!Object.keys(action.user).length,
        user: action.user
      }
    case UPDATE_USER:
      return {
        ...state,
        user: {...action.payload}
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/currentUser.js